<template>
  <div class="container">
    <breadcrumbs :breadcrumbs="breadcrumbs"/>
    <div class="news-content">
      <div class="date-name">
        <h1 class="name-news">{{ newsLocaleData.title }}</h1>
        <span class="date">{{ newsItem.date|formatDateNews }}</span>
      </div>
      <div class="news-block-content">
        <Content :page="{content: newsItem.body}"/>
      </div>
    </div>
  </div>
</template>

<script>
import {rememberExpiresMixin} from "@/mixins";
import {NewsItem} from '@/models/news';

import Breadcrumbs from '@/components/breadcrumbs';
import Content from '@/components/content';

export default {
  components: {
    Breadcrumbs,
    Content,
  },
  mixins: [rememberExpiresMixin],
  computed: {
    newsLocaleData() {
      return this.newsItem.news_item_translations?.find(x => x.language.slug === this.$i18n.locale) || {};
    },
    breadcrumbs() {
      return [{
        name: this.$t('all_news'),
        link: this.localePath('/news/'),
      }, {
        name: this.newsLocaleData.title,
      }];
    },
  },
  async asyncData(context) {
    try {
      return {
        newsItem: await NewsItem.config({count_loading: true}).find(context.route.params.id),
      }
    } catch (e) {
      context.error({statusCode: e.response.status});
    }
  },
  head() {
    if (this.newsLocaleData.title) {
      return {
        title: `${this.newsLocaleData.title} - ${this.$t('news')}`
      }
    }
  },
}
</script>
